import React from "react";
import { Layout, Row, Col, Spin } from 'antd';

// ICONS
import { LoadingOutlined } from '@ant-design/icons';

const Pageload = () => {
    const { Content } = Layout;

    return (
        <Layout>
            <Content className="loading__content">
                <Row align={'middle'} justify={'center'} style={{ height: '100vh' }}>
                    <Col>
                        <Spin size="large" indicator={<LoadingOutlined style={{ color: 'var(--tom-1)' }} spin />} />
                    </Col>
                </Row>
            </Content>
        </Layout>
    )
}

export default Pageload;